/*
 * @Author: Latte
 * @Date: 2021-07-23 16:59:15
 * @LAstEditors: Latte
 * @LastEditTime: 2021-08-03 10:57:11
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\diagnosisManagement\diagnosticRoleApplication.js
 */

import request from '@/utils/request'
import config from '@/utils/config'
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * @description: 后台管理分页查询所有会诊用户申请记录
 * @param {*} params
 * @return {*}
 */
export function getAllRoleApplication(params) {
	let url = config.API_TELEMEDICINE + "/tel_server/manage/consultation/user/req/list?";
	url = handleUrlEncode(url,params)
	return request({
		url: url,
		method: "get",
	});
}

/**
 * @description: 后台管理分页获取所有的会诊角色用户
 * @param {*} params
 * @return {*}
 */
export function getAllRoleList(params) {
	return request({
		url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/user/list',
		method: 'get',
		params
	})
}

/**
 * @description: 后台管理查询单个会诊角色用户详情
 * @param {*} params
 * @return {*}
 */
export function getRoleDetail(params) {
	return request({
		url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/user/detail',
		method: 'get',
		params
	})
}

/**
 * @description: 后台管理删除会诊用户
 * @param {*} params
 * @return {*}
 */
export function deleteRole(params) {
	return request({
		url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/user/delete',
		method: 'delete',
		params
	})
}

/**
 * @description: 后台管理删除会诊用户申请
 * @param {*} params
 * @return {*}
 */
export function deleteRoleApplication(params) {
	return request({
		url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/user/req/deleteOrBack',
		method: 'delete',
		params
	})
}

/**
 * @description: 后台管理恢复会诊用户申请
 * @param {*} params
 * @return {*}
 */
export function resumeRoleApplication(params) {
	return request({
		url: config.API_TELEMEDICINE + '/tel_server/manage/consultation/user/req/deleteOrBack',
		method: 'delete',
		params
	})
}

/**
 * @description: 后台管理审核会诊用户申请
 * @param {*} params
 * @return {*}
 */
export function updateRoleApplication(data) {
	return request({
		url: config.API_TELEMEDICINE + "/tel_server/manage/consultation/user/req/audit",
		data: data,
		method: "patch",
	});
}

export function getConsultationUserService(data) {
	return [{
			id: 0,
			name: "会诊服务"
		},
		{
			id: 1,
			name: "云存储服务"
		},
		{
			id: 2,
			name: "视频直播服务"
		},
		{
			id: 3,
			name: "视频会议服务"
		},
	]
}
